export const PROMO_CODE_PROMOTION = 'promo_code'
export const CTA_PROMOTION = 'cta'
export const FLIGHT_VOUCHER_PROMOTION = 'flight_voucher'

interface BasePromotion {
  label: string
  title: string
  subtitle: string
  expiresAt?: string
  eligibleRegions: Array<string>
}

export interface PromoCodePromotion extends BasePromotion {
  type: typeof PROMO_CODE_PROMOTION
  promoCode: string
  termsAndConditions: string
  primaryActionText?: string
  primaryActionHref?: string
}

export interface CtaPromotion extends BasePromotion {
  type: typeof CTA_PROMOTION
  ctaText: string
  ctaLink: string
}

export interface FlightVoucherPromotion extends BasePromotion {
  type: typeof FLIGHT_VOUCHER_PROMOTION
}

export type LandingPagePromotion =
  | PromoCodePromotion
  | CtaPromotion
  | FlightVoucherPromotion
